import * as React from "react";
import { useId } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCubes = (props) => {
	const __svgrId = useId();
	return /* @__PURE__ */ _jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 512 512",
		...props,
		children: /* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M284-1.3c-17.3-10-38.7-10-56 0L143.8 47.3c-17.3 10-28 28.5-28 48.5l0 101.9-88.3 51c-17.3 10-28 28.5-28 48.5l0 97.3c0 20 10.7 38.5 28 48.5l84.3 48.6c17.3 10 38.7 10 56 0l88.3-51 88.3 51c17.3 10 38.7 10 56 0L484.5 443c17.3-10 28-28.5 28-48.5l0-97.3c0-20-10.7-38.5-28-48.5l-88.3-51 0-101.9c0-20-10.7-38.5-28-48.5L284-1.3zM71.5 278.7l68.3-39.4 68.3 39.4-68.3 39.4-68.3-39.4zm-24 41.6l68.3 39.4 0 78.8-64.3-37.1c-2.5-1.4-4-4.1-4-6.9l0-74.2zM163.8 438.5l0-78.8 68.3-39.4 0 78.8-68.3 39.4zM280 320.3l68.3 39.4 0 78.8-68.3-39.4 0-78.8zM396.3 438.5l0-78.8 68.3-39.4 0 74.2c0 2.9-1.5 5.5-4 6.9l-64.3 37.1zm44.3-159.8l-68.3 39.4-68.3-39.4 68.3-39.4 68.3 39.4zM280 237.2l0-78.8 68.3-39.4 0 78.8-68.3 39.4zM324.3 77.4L256 116.8 187.8 77.4 252 40.3c2.5-1.4 5.5-1.4 8 0l64.3 37.1zM163.8 118.9l68.3 39.4 0 78.8-68.3-39.4 0-78.8z"
		})
	});
};
export default SvgCubes;
